module.exports = __webpack_public_path__ + "img/cienaga1400.35a3ec59.jpg";